import { render, staticRenderFns } from "./SessionWaitStep.vue?vue&type=template&id=10a3df11"
import script from "./SessionWaitStep.vue?vue&type=script&lang=js"
export * from "./SessionWaitStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports